import React from "react";
import { Link } from "react-router-dom";
import { Cards } from "../../shared";

function NotAuthorized() {
  return (
    <div className="container">
      <div className="text-wrapper">
        <div className="title" data-content="404">
          Unauthorized
        </div>

        <div className="subtitle">Please login to continue.</div>

        <div className="buttons">
          <Link to="/">
            <span className="button">Go to homepage</span>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NotAuthorized;
